// A render thumbnail that comes either from a content-addressed blob (synced
// renders → AssetImage) or a direct presigned URL (job-fallback renders).
import { AssetImage } from "./AssetImage";

export function RenderThumb({
  s3Key,
  url,
  alt,
  className,
  onClick,
}: {
  s3Key?: string;
  url?: string;
  alt: string;
  className?: string;
  onClick?: () => void;
}) {
  if (url) {
    return (
      <div
        className={`relative overflow-hidden bg-cream ${onClick ? "cursor-pointer" : ""} ${className ?? ""}`}
        onClick={onClick}
      >
        <img src={url} alt={alt} loading="lazy" className="h-full w-full object-cover" />
      </div>
    );
  }
  return <AssetImage s3Key={s3Key} alt={alt} className={className} onClick={onClick} />;
}
